<template>
  <div class="property-tab">
    <div class="property-title d-flex flex-row">
      <div class="flex-grow-1">Transition Behavior:</div>
      <v-tooltip location="bottom">
        <template #activator="{ props }">
          <v-btn-icon
            size="fit-content"
            icon="mdi-help-circle-outline"
            v-bind="props"
            href="https://www.itemis.com/en/yakindu/state-machine/documentation/user-guide/quick_ref_states_transitions#quick_ref_transition_reactions"
            target="_blank"
          >
          </v-btn-icon>
        </template>
        <span>Open Documentation</span>
      </v-tooltip>
    </div>
    <specification-editor :model="model" :specification="specification" class="bordered" />
    <documentation-editor :model="model" />
  </div>
</template>

<script setup lang="ts">
import { Transition } from "../mvc/transition";
import SpecificationEditor from "../StatechartDefinitionsView/SpecificationEditor.vue";
import DocumentationEditor from "../StatechartDefinitionsView/DocumentationEditor.vue";
import { computed, onMounted, onBeforeUnmount, ref } from "vue";

const compProps = defineProps<{
  model: Transition;
}>();

const emit = defineEmits(["notifyChange"]);

const specification = ref(compProps.model.getSpecification());

const changeNotifier = (model) => {
  specification.value = compProps.model.getSpecification();
  emit("notifyChange", model);
};

onMounted(() => {
  compProps.model.on("change", changeNotifier, compProps.model);
});

onBeforeUnmount(() => {
  compProps.model.off("change", changeNotifier);
});
</script>
